import React, { useCallback } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { getEquipmentColorClass } from 'helpers/_helpers';
import styles from './styles';
import useWorklogStyles from 'components/WorklogDetails/hooks/useWorklogStyles';
import { useResourceHoursChanges } from 'components/WorklogDetails/hooks/useResourceHoursChanges';

const EquipmentItem = ({
  classes,
  equipmentData,
  getFormattedHoursRange,
  displayDifference,
  historyItem,
  removed,
  // hasAccess,
  // openUserWorklogs,
}) => {
  const worklogClasses = useWorklogStyles();

  const getEquipmentInfo = (field) => {
    if (field === 'number') {
      return equipmentData.number || parseInt(equipmentData.name);
    }
    if (field === 'className') {
      return getEquipmentColorClass(equipmentData.color);
    }
    return equipmentData[field];
  };


  const isItemChanged = displayDifference && historyItem?.action === 'changed';
  const isItemAdded = displayDifference && historyItem?.action === 'added';
  const { hoursChanges, removedHours } = useResourceHoursChanges(equipmentData?.hours, historyItem?.prevState?.hours, isItemAdded);

  return (
    <Grid
      container
      className={classnames(
        worklogClasses.resourceBlockItem,
        isItemAdded ? worklogClasses.showDiff : null,
        removed ? worklogClasses.showDiffRemoved : null,
      )}
    >
      <Grid item xs={5} md={equipmentData.hours ? 3 : 12}>
        <div
          className={classnames(
            classes.equipmentBlock,
            getEquipmentInfo('className'),
            // hasAccess && classes.clickable
          )}
          // onClick={hasAccess ? openUserWorklogs : () => null}
        >
          <div
            className={classes.equipmentNumber}
            style={{ backgroundColor: getEquipmentInfo('color') }}
          >
            {getEquipmentInfo('number') || ''}
          </div>
          <div
            className={classes.equipmentName}
            style={{ color: getEquipmentInfo('color') }}
          >
            {getEquipmentInfo('name')}
          </div>
        </div>
      </Grid>
      <Grid container item xs={7} md={8} spacing={2}>
        <Grid item xs={12} md={5} className={classes.flex}>
          {!!equipmentData.hours?.length ? equipmentData.hours.map((hoursPair, i) => (
            <div className={classnames(classes.inlineFlex, classes.resourceHoursValues)}>
              <Typography
                variant="body1"
                color="textPrimary"
                className={classnames(
                  ((isItemChanged && (hoursChanges?.[i]?.hoursChanged || hoursChanges?.[i]?.hoursAdded))
                    ? worklogClasses.showDiff
                    : null),
                  removed ? worklogClasses.lineThrough : null,
                )}
              >
                {getFormattedHoursRange(hoursPair)}
              </Typography>
            </div>
          )) : null}
          {!!removedHours?.length ? removedHours.map((hoursPair) => (
            <div className={classnames(classes.inlineFlex, classes.resourceHoursValues)}>
              <Typography
                variant="body1"
                color="textPrimary"
                className={classnames(worklogClasses.showDiffRemoved)}
              >
                {getFormattedHoursRange(hoursPair)}
              </Typography>
            </div>
          )) : null}
        </Grid>
      </Grid>
    </Grid>
  );
};

EquipmentItem.propTypes = {
  classes: propTypes.object.isRequired,
  equipmentData: propTypes.object.isRequired,
  getFormattedHoursRange: propTypes.func.isRequired,
};

export default withStyles(styles)(EquipmentItem);
